import { create } from "zustand";

/**
 * Cross-component visibility signal for the Settings ActivationBanner
 * (`?billing=success|cancel` Checkout-return banner).
 *
 * Why a store: SettingsPage captures + STRIPS the `?billing=` param on mount
 * (history.replaceState) and keeps the return state in component state, so
 * nothing outside SettingsPage can tell from the URL that the activation
 * banner is on screen. The ProLayout-level UnusedDiscountBanner must not
 * double-stack with it, so ActivationBanner publishes its own rendered-ness
 * here (set true while it renders content, false on unmount / null branches)
 * and the discount banner subscribes. Mirrors the app's zustand store idiom
 * (stores/today.ts et al) at minimal size.
 */
interface ActivationBannerState {
  /** True while the Settings ActivationBanner is rendering visible content. */
  visible: boolean;
  setVisible: (visible: boolean) => void;
}

export const useActivationBannerStore = create<ActivationBannerState>(
  (set) => ({
    visible: false,
    setVisible: (visible) => set({ visible }),
  }),
);
